import React from 'react';
import { element, func } from 'prop-types';
import { Container } from './icon-button.styles';

function handleClick(e, onClick) {
  onClick(e);
}

function IconButton({
  onClick,
  children
}) {
  return /*#__PURE__*/React.createElement(Container, {
    onClick: e => handleClick(e, onClick)
  }, children);
}

process.env.NODE_ENV !== "production" ? IconButton.propTypes = {
  onClick: func.isRequired,
  children: element.isRequired
} : void 0;
export default IconButton;